module.exports = __webpack_public_path__ + "img/bitmap.d7b1c468.png";